/**
 * WordPress dependencies
 */
export * from '@wordpress/block-editor';

import { store } from '@wordpress/block-editor';
import type Actions from '@wordpress/block-editor/store/actions';
import type Selectors from '@wordpress/block-editor/store/selectors';
declare module '@wordpress/data' {
	function dispatch( key: typeof store ): typeof Actions;
	function select( key: typeof store ): typeof Selectors;
}
